import { getFileURL } from '@/lib/helpers/FileURLGetter'
import camelcaseKeys from 'camelcase-keys'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { ReservationMethod } from '@/entities/activities/ReservationMethod'

export class Activity {
  constructor (params = {}, relatedActivities = []) {
    const { id, categoryIds, name, description, coverImageId, facilityId, imageIds, catalogFileId, reservationMethods, ticketTemplateFileId, stationId, active, relatedActivityIds, catalogCallToAction } = params ? camelcaseKeys(params) : {}
    this.id = id || null
    this.categoryIds = categoryIds || []
    this.name = name ? getTextValue(name) : null
    this.description = description ? getTextValue(description) : null
    this.coverImageId = coverImageId || null
    this.coverImageUrl = coverImageId ? getFileURL(coverImageId) : null
    this.facilityId = facilityId || null
    this.imageIds = imageIds || []
    this.images = this.imageIds ? this.imageIds.map((image) => {
      return getFileURL(image)
    }) : []
    this.catalogFileId = catalogFileId || null
    this.reservationMethods = reservationMethods ? reservationMethods.map((item) => {
      return new ReservationMethod(item)
    }) : []
    this.ticketTemplateFileId = ticketTemplateFileId || null
    this.stationId = stationId
    this.active = active
    this.relatedActivityIds = relatedActivityIds
    this.relatedActivities = relatedActivities
    this.catalogCallToAction = catalogCallToAction ? getTextValue(catalogCallToAction) : null
  }
}
